import * as R from 'ramda';

export function getArrayChange<T>(utilities: T[], nextUtilities: T[]): [T, boolean] {
  if (utilities.length < nextUtilities.length) {
    return [R.without(utilities, nextUtilities)[0], true];
  } else {
    return [R.without(nextUtilities, utilities)[0], false];
  }
}
